export const removeUndefinedValues = (obj: Record<string, unknown>) => {
  return Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined));
};

export function toURLSearchParams(params: Record<string, unknown>): URLSearchParams {
  const filteredParams = removeUndefinedValues(params);

  return new URLSearchParams(filteredParams as Record<string, string>);
}
